import React from "react";

interface SecurityCardProps {
  title: string;
  description: string;
  buttonLabel?: string;
  childTextButtons?: any;
  onButtonClick?: () => void;
}

const SecurityCard: React.FC<SecurityCardProps> = ({
  title,
  description,
  buttonLabel,
  onButtonClick,
  childTextButtons,
}) => {
  return (
    <div className="flex justify-between items-center  p-6 shadow-md gap-4">
      <div>
        <p className="text-sm font-medium">{title}</p>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
      <button
        className="text-accent text-sm font-medium hover:underline"
        onClick={onButtonClick}
      >
        {buttonLabel}
      </button>
      <button className="text-accent text-sm font-medium hover:underline">
        {childTextButtons}
      </button>
    </div>
  );
};

export default SecurityCard;
